import { ApplicantCompanyType, CompanyStructure, State, TrustType } from '@lendi/core-constants';

import { GuarantorRelationshipType, INVITATION_STATUS } from '@funnels/constants';

import { Address } from './address';

export enum HousingStatus {
  RENTING = 'Renting',
  BOARDING = 'Boarding',
  CARAVAN = 'Caravan',
  OTHER = 'Other',
  OWN_HOME = 'Own Home',
  OWN_HOME_MORTGAGE = 'Own Home Mortgage',
  SUPPLIED_BY_EMPLOYER = 'Supplied by Employer',
  WITH_PARENTS = 'With Parents',
}

export enum YesNoIntend {
  YES = 'Yes',
  NO = 'No',
  INTEND = 'Intend',
}
interface CurrentAddress {
  housingStatus?: HousingStatus;
  residentialAddress?: Address;
  startDate?: string;
}

interface PreviousAddress {
  endDate?: string;
  housingStatus?: HousingStatus;
  startDate?: string;
  residentialAddress?: Address;
}

export interface Contact {
  currentAddress?: CurrentAddress;
  mailingAddress?: Address;
  emailAddress?: string;
  mobileNumber?: string;
  previousAddresses?: PreviousAddress[];
}

export interface MaritalDetails {
  applicantId?: string;
}

export interface Dependant {
  age?: number;
  id?: string;
  isAddedOnThisApplicant?: boolean;
  sharedWith?: SharedWith;
}

export interface SharedWith {
  applicantId?: string;
}

interface Applicant {
  /**
   * `@funnels/constants` ApplicantType
   */
  applicantType?: string;
  /**
   * `@funnels/constants` ApplicantEntity
   */
  entity?: string;

  contact?: Contact;
  creditStatus?: string;
  customerId?: string;
  dateOfBirth?: string;
  dependants?: Dependant[];
  employmentType?: string;
  firstName?: string;
  gender?: string;
  hasSelfEmploymentProof?: boolean;
  maritalDetails?: MaritalDetails;
  maritalStatus?: string;
  middleName?: string;
  residencyStatus?: string;
  lastName?: string;
  title?: string;
  totalIncomeEstimate?: number;
  invitationStatus?: INVITATION_STATUS;
  guarantorRelationshipToBorrower?: GuarantorRelationshipToBorrower;
  countryOfBirth?: string;
  cityOfBirth?: string;
  citizenship?: string;
  mothersMaidenName?: string;

  // Company
  companyName?: string;
  companyType?: ApplicantCompanyType;
  companyStructure?: CompanyStructure;
  abn?: string;
  acn?: string;
  isNotRegistered?: boolean;
  registeredState?: State;
  currentLender?: string;
  legalEntitiesInGroup?: number;
  legalEntitiesWithCurrentLender?: number;
  monthsWithCurrentLender?: number;
  yearsOfTrading?: '1' | '2' | '3' | '4' | '5' | '5-10' | '>10';
  branch?: string;
  isDiversified?: boolean;
  isCommercialRelationship?: boolean;
  hasMoreThan25PercentBusinessWithOneCustomer?: boolean;
  moreThan25PercentBusinessWithOneCustomerDetails?: string;
  hasOutstandingTax?: boolean;
  outstandingTaxDetails?: string;
  isPrincipalPlaceOfBusinessLeased?: boolean;
  principalPlaceOfBusinessLeasedDetails?: string;
  doesTermLoanNeed100PercentFunding?: boolean;
  termLoanNeed100PercentFundingDetails?: string;
  isActingAsFranchise?: YesNoIntend;
  actingAsFranchiseDetails?: string;
  isWorkingInImportExport?: YesNoIntend;
  workingInImportExportDetails?: string;
  isInvestingInProperty?: YesNoIntend;
  investingInPropertyDetails?: string;
  hasGoodConduct?: boolean;
  wasBankruptOrInsolvent?: boolean;
  hasPastOrCurrentDebts?: boolean;
  hadRepaymentDifficultyOrLegalProceedings?: boolean;
  isUSCitizenOrResident?: boolean;
  hadLatePaymentsOrArrearsOrAdverseCreditHistory?: boolean;

  // Trust
  trustName?: string;
  trustType?: TrustType;
  registeredCountry?: string;
  registeredAddress?: Address;
  mailingAddress?: Address;

  // Company Trust shared
  industryCode?: string;
  isPassiveEntity?: boolean;
  registeredDate?: string;
}

export interface GuarantorRelationshipToBorrower {
  applicantId: string;
  type: GuarantorRelationshipType;
  typeOther?: string;
}

export type ServerApplicantCreate = Applicant;
export type ServerApplicantUpdate = Omit<Applicant, 'entity'>;
export interface ServerApplicantFetch extends Applicant {
  id: string;
}

export interface StoreApplicant extends Applicant {
  clientId: string;
  id?: string;
  clonedFromApplicantId?: string;
}

export interface IndexedStoreApplicant extends StoreApplicant {
  applicantIndex: number;
}
